/**
 * @param {string[]} userPermissions
 */
export const createHasPermissions = userPermissions => requiredPermissions => {

  const permissionsFound = requiredPermissions.filter(permission => userPermissions.includes(permission))

  return permissionsFound.length === requiredPermissions.length
}
